


































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DialogMixin } from "../mixins";
import DateTimeSelector from "../selectors/DateTimeSelector.vue";

@Component({
  components: {
    DateTimeSelector,
  }
})
export default class DateTimeSelectDialog extends Mixins(DialogMixin) {
  $refs!: {
    dateTimeSelector: DateTimeSelector;
  };

  data(): any {
    return {
      selectedDateTime: null as Date,
      selectedInfo: null as Date,
    };
  }
  selectedDateTime: Date;
  selectedInfo: Date;

  @Prop({ default: true })
  isClearable: boolean;

  async show(date: Date): Promise<Date> {
    return this.showModal(async () => {
      this.selectedDateTime = date
        ? date
        : new Date();
      this.selectedInfo = date;
      await this.waitHidden();
      return this.selectedInfo;
    });
  }

  applyValue(value: Date) {
    this.selectedInfo = value;
    this.isVisible = false;
  }

  cancel(): void {
    this.selectedInfo = undefined;
    this.isVisible = false;
  }

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean) {
    if (newValue) {
      this.$nextTick(() => {
        if (this.$refs.dateTimeSelector) {
          this.$refs.dateTimeSelector.setFocus();
        }
      });
    }
  }
}
